import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import ReconcilableRow, { ReconcilableItem } from './_ReconcilableRow'

const ReconciliationTable = ({ reconcilableItems }: { reconcilableItems: ReconcilableItem[] }) => {
  const { access } = useCurrentSession()

  const EmptyState = () => (
    <Table.Row>
      <Table.Cell colSpan={4}>
        <Box
          height="full"
          width="full"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          paddingX="s24"
        >
          <Box
            flexDirection="column"
            gap="s8"
            width="s400"
            paddingX="s24"
            textAlign="center"
            alignItems="center"
          >
            <Icon.Large icon="workflow" color="grey600" />
            <Text.Header2>
              {i18n.t('finance.invoices.detail.reconciliations.table.empty_state_v2.title')}
            </Text.Header2>
            <Text.Normal color="grey800">
              {i18n.t('finance.invoices.detail.reconciliations.table.empty_state_v2.description')}
            </Text.Normal>
          </Box>
        </Box>
      </Table.Cell>
    </Table.Row>
  )

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell background="grey000White" width={108} paddingX="s4" ellipsis>
            <Box style={{ paddingLeft: '20px' }}>
              {i18n.t('finance.invoices.detail.reconciliations.table.header.date')}
            </Box>
          </Table.HeadCell>
          <Table.HeadCell paddingX="s4" background="grey000White" ellipsis>
            {i18n.t('finance.invoices.detail.reconciliations.table.header.description')}
          </Table.HeadCell>
          <Table.HeadCell
            background="grey000White"
            width={100}
            paddingX="s4"
            ellipsis
            justifyContent="flexEnd"
          >
            <Box>{i18n.t('finance.invoices.detail.reconciliations.table.header.amount')}</Box>
          </Table.HeadCell>
          <Table.HeadCell
            background="grey000White"
            width={50}
            paddingX="s4"
            ellipsis
            justifyContent="flexEnd"
          >
            <Box></Box>
          </Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {reconcilableItems.length > 0 &&
          reconcilableItems.map((reconcilableItem) => (
            <ReconcilableRow
              key={reconcilableItem.id}
              reconciliationItem={reconcilableItem}
              locale={access.locale}
            />
          ))}
        {reconcilableItems.length === 0 && <EmptyState />}
      </Table.Body>
    </Table>
  )
}

export default ReconciliationTable
